(() => {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const replay = (element, className) => {
    if (!element) return;
    element.classList.remove(className);
    void element.offsetWidth;
    element.classList.add(className);
  };

  const purchaseButtonFor = (element) =>
    element.closest('product-info, .product, .quick-add-modal, .featured-product')?.querySelector(
      '.product-form__submit:not([disabled])'
    );

  document.addEventListener('change', (event) => {
    if (!event.target.matches('variant-selects select, variant-radios input, .product-form__input select, .product-form__input input')) {
      return;
    }

    window.setTimeout(() => replay(purchaseButtonFor(event.target), 'motion-atc-ready'), 80);
  });

  document.addEventListener(
    'pointerdown',
    (event) => {
      const button = event.target.closest('.product-form__submit, .cap-bundle__add');
      if (!button) return;

      const required = Number(button.dataset.requiredFields || 0);
      const valid = Number(button.dataset.validFields || 0);
      const container = button.closest('product-form, cap-bundle-builder');
      const findVisibleError = () =>
        container?.querySelector(
          '.product-form__error-message-wrapper:not([hidden]), .main-atc__error:not([style*="display:none"]), .cap-bundle__error:not(:empty)'
        );

      if (button.disabled || valid < required || findVisibleError()) {
        replay(button, 'motion-error-shake');
      }

      window.setTimeout(() => {
        if (findVisibleError()) replay(button, 'motion-error-shake');
      }, 180);
    },
    true
  );

  const cartIcon = document.getElementById('cart-icon-bubble');
  const cartObserverTarget = cartIcon?.parentElement || cartIcon;

  if (cartObserverTarget) {
    let cartReady = false;
    const cartObserver = new MutationObserver(() => {
      if (cartReady) replay(document.getElementById('cart-icon-bubble'), 'motion-cart-bounce');
      cartReady = true;
    });

    cartObserver.observe(cartObserverTarget, { childList: true, subtree: true, characterData: true });
    window.setTimeout(() => {
      cartReady = true;
    }, 500);
  }

  const revealObserver = new IntersectionObserver(
    (entries, observer) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('motion-in-view');
        observer.unobserve(entry.target);
      });
    },
    { threshold: 0.25 }
  );

  const observeMotionElements = (root = document) => {
    root
      .querySelectorAll(
        '.cap-bundle__builder, .bundle-invitation, .rating-stars, .trustpilot-review, .cart-progress'
      )
      .forEach((element) => {
        if (!element.dataset.motionObserved) {
          element.dataset.motionObserved = 'true';
          revealObserver.observe(element);
        }
      });
  };

  const progressObserver = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      const progress = mutation.target.closest?.('.cart-progress__bar__progress');
      if (progress) replay(progress, 'motion-progress-update');
    });
    observeMotionElements();
  });

  const start = () => {
    observeMotionElements();
    progressObserver.observe(document.body, {
      attributes: true,
      attributeFilter: ['style'],
      childList: true,
      subtree: true
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', (event) => observeMotionElements(event.target));
})();
